// src/components/AddCompanyForm/AddressLegalCard.jsx
import React from "react";
import {
  Box,
  Card,
  CardHeader,
  CardContent,
  Grid,
  TextField,
  InputAdornment,
  Typography,
} from "@mui/material";
import PublicRoundedIcon from "@mui/icons-material/PublicRounded";
import RoomRoundedIcon from "@mui/icons-material/RoomRounded";
import BadgeRoundedIcon from "@mui/icons-material/BadgeRounded";
import PinDropRoundedIcon from "@mui/icons-material/PinDropRounded";
import ExploreRoundedIcon from "@mui/icons-material/ExploreRounded";
import { useTranslation } from "react-i18next";
import { onlyDigits, formatCepInput } from "./utils";

export default function AddressLegalCard({ form, setForm }) {
  const { t } = useTranslation("settings");
  const set = (patch) => setForm((p) => ({ ...p, ...patch }));

  return (
    <Card variant="outlined" sx={{ height: "100%" }}>
      <CardHeader
        title={t("addCompanyForm.address.title")}
        subheader={t("addCompanyForm.address.subheader")}
      />
      <CardContent sx={{ pt: 0 }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label={t("addCompanyForm.address.siteLabel")}
              value={form.site}
              onChange={(e) => set({ site: e.target.value })}
              fullWidth
              placeholder="https://suaempresa.com.br"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <PublicRoundedIcon fontSize="small" />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label={t("addCompanyForm.address.addressLabel")}
              value={form.endereco}
              onChange={(e) => set({ endereco: e.target.value })}
              fullWidth
              multiline
              minRows={2}
              maxRows={4}
              placeholder={t("addCompanyForm.address.addressPlaceholder")}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start" sx={{ alignSelf: "flex-start", mt: 1.2 }}>
                    <RoomRoundedIcon fontSize="small" />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12} sm={5} md={4}>
            <TextField
              label={t("addCompanyForm.address.unitCepLabel")}
              value={form.cep}
              onChange={(e) => set({ cep: formatCepInput(e.target.value) })}
              fullWidth
              placeholder={t("addCompanyForm.address.unitCepPlaceholder")}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <PinDropRoundedIcon fontSize="small" />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={7} md={8}>
            <TextField
              label={t("addCompanyForm.address.cnpjLabel")}
              value={form.cnpj}
              onChange={(e) => set({ cnpj: onlyDigits(e.target.value).slice(0, 14) })}
              fullWidth
              placeholder="00.000.000/0000-00"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <BadgeRoundedIcon fontSize="small" />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <Box
              sx={{
                pt: 0.5,
                pb: 0.5,
                borderTop: 1,
                borderColor: "divider",
              }}
            >
              <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
                {t("addCompanyForm.address.coordsSection")}
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label={t("addCompanyForm.address.latitudeLabel")}
              value={form.latitude}
              onChange={(e) => set({ latitude: e.target.value })}
              fullWidth
              placeholder="-23.3045"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <ExploreRoundedIcon fontSize="small" />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label={t("addCompanyForm.address.longitudeLabel")}
              value={form.longitude}
              onChange={(e) => set({ longitude: e.target.value })}
              fullWidth
              placeholder="-51.1696"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <ExploreRoundedIcon fontSize="small" />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: -1 }}>
              {t("addCompanyForm.address.geoHelper")}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
